import React from 'react';
import styles from './pmndp-enhanced.module.css';

const PMNDPConfirmDialog = ({
  isOpen,
  title,
  message,
  type = 'warning',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return 'fa-exclamation-triangle';
      case 'info':
        return 'fa-info-circle';
      case 'success':
        return 'fa-check-circle';
      case 'warning':
      default:
        return 'fa-exclamation-triangle';
    }
  };

  const getConfirmButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'pmndp-confirm-btn-danger';
      case 'success':
        return 'pmndp-confirm-btn-primary';
      case 'info':
      case 'warning':
      default:
        return 'pmndp-confirm-btn-primary';
    }
  };

  return (
    <div className="pmndp-confirm-dialog">
      <div className="pmndp-confirm-content">
        <div className={`pmndp-confirm-icon ${type}`}>
          <i className={`fa ${getIcon()}`}></i>
        </div>
        
        <h3 className="pmndp-confirm-title">{title}</h3>
        <p className="pmndp-confirm-message">{message}</p>
        
        <div className="pmndp-confirm-actions">
          <button
            className="pmndp-confirm-btn pmndp-confirm-btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          
          <button
            className={`pmndp-confirm-btn ${getConfirmButtonClass()}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                Processing...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PMNDPConfirmDialog;
